/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GeoJsonEssentialServiceProperties } from "models/essential-services.model";
import { GetEssentialServicesGeojsonState } from "store/modules/posts/types";

const initialState: GetEssentialServicesGeojsonState = {
    isRequesting: false,
    successPayload: null,
    errors: []
};

const getEssentialServicesGeojsonSlice = createSlice({
    name: "posts@getEssentialServicesGeojson",
    initialState,
    reducers: {
        getEssentialServicesGeojsonRequest: (
            state            
        ): void => {
            state.isRequesting = true;
            state.errors = [];
        },
        getEssentialServicesGeojsonSuccess: (
            state,
            action: PayloadAction<GeoJSON.FeatureCollection<GeoJSON.Point, GeoJsonEssentialServiceProperties>>
        ): void => {
            state.isRequesting = false;
            state.successPayload = action.payload;
        },
        getEssentialServicesGeojsonFailed: (
            state,
            action: PayloadAction<string[]>
        ): void => {
            state.isRequesting = false;
            state.errors = action.payload;
        }
    }
});

export const {
    getEssentialServicesGeojsonFailed,
    getEssentialServicesGeojsonRequest,
    getEssentialServicesGeojsonSuccess
} = getEssentialServicesGeojsonSlice.actions;
export default getEssentialServicesGeojsonSlice.reducer;
